export default __webpack_public_path__ + "static/creatively-hero-d86e614e3084c3e3d5e985a391980b66.avif";